import React from 'react'
// import 'bootstrap/dist/css/bootstrap.min.css';
import { TelephoneFill, EnvelopeFill, GeoAltFill } from "react-bootstrap-icons";


const ContactUs = () => {
  return (
    <div>
        <section className="welcome_area contact" id="home">
        <div className="container">
          <div className="row align-items-center">
             
            <div className="col-12 col-lg-6 col-md-12">
              <div className="welcome-content">
                <div className="promo-section">
                  <div className="integration-link">
                    <div className="integration-icon">
                      <p className="badge"> Contact Us</p>
                    </div>
                    <span className="integration-text">
                      Get Realtime payments &amp; grow your business!
                    </span>
                  </div>
                </div>
                <h1 className="b-text bold">
                  Transfer Money Across The World In Real Time.
                </h1>
                <p>
                  We have over 15 year exprience in Payment consultting arena. We have
                  over 15 year exprience in Payment consultting arena and artficial
                  intelligence.
                </p>
                <div className="dream-btn-group fadeInUp" data-wow-delay="0.4s">
                  <a href="contact.html" className="btn more-btn mr-3">
                    About us
                  </a>
                  <a className="btn more-btn" href="services.html">
                     
                    Apply For Loan
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6"></div>
          </div>
        </div>
      </section>


      <div className="container py-5">
      <div className="row">

        {/* LEFT SIDE */}
        <div className="col-lg-5 mb-4">

          <p className="text-muted">
            Get in touch with us <span className="ms-2 border-bottom border-3 border-info d-inline-block" style={{width:"40px"}}></span>
          </p>

          <h2 className="fw-bold mb-4" style={{color:"#1b6d7a"}}>
            For any query call us
          </h2>

          {/* Call */}
          <div className="d-flex align-items-center mb-4">
            <div className="bg-info text-white rounded-circle d-flex justify-content-center align-items-center"
              style={{width:"70px", height:"70px"}}>
              <TelephoneFill size={28}/>
            </div>
            <div className="ms-3">
              <h5 className="fw-bold mb-1">Call Anytime</h5>
              <p className="mb-0 text-muted">18008917271</p>
            </div>
          </div>

          <hr />

          {/* Email */}
          <div className="d-flex align-items-center mb-4">
            <div className="bg-info text-white rounded-circle d-flex justify-content-center align-items-center"
              style={{width:"70px", height:"70px"}}>
              <EnvelopeFill size={28}/>
            </div>
            <div className="ms-3">
              <h5 className="fw-bold mb-1">Write Email</h5>
              <p className="mb-0 text-muted">info@meloans.in</p>
            </div>
          </div>

          <hr />


           <div className="d-flex align-items-center mb-4">
            <div className="bg-info text-white rounded-circle d-flex justify-content-center align-items-center"
              style={{width:"70px", height:"70px"}}>
              <GeoAltFill size={28}/>
            </div>
            <div className="ms-3">
              <h5 className="fw-bold mb-1"> Office Address</h5>
              <p className="mb-0 text-muted"> Hyderabad</p>
            </div>
          </div>

          

        </div>

        {/* RIGHT SIDE FORM */}
        <div className="col-lg-7">
          <form className="p-4 bg-light rounded shadow-sm">

            <div className="row">
              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Your Name"
                />
              </div>

              <div className="col-md-6 mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Your Email"
                />
              </div>

              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Phone Number"
                />
              </div>

              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Subject"
                />
              </div>

              <div className="col-12 mb-3">
                <textarea
                  className="form-control"
                  rows="5"
                  placeholder="Write Message"
                ></textarea>
              </div>

              <div className="col-12">
                <button className="btn btn-info text-white px-4 py-2">
                  Send A Message
                </button>
              </div>
            </div>

          </form>
        </div>

      </div>
    </div>



      
      
    </div>
  )
}

export default ContactUs
